var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calendar-header",style:({ 'grid-template-columns' : `repeat(${_vm.onlyWeekDay === false ? '7' : '5'}, 1fr)`  })},_vm._l((_vm.dayLabel),function(day,index){return _c('div',{key:index + day},[_vm._v(" "+_vm._s(day)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }